
import { Component, Vue } from 'vue-property-decorator'

import BacButton from '@/components/BacButton.vue'
import PictureChooser from './PictureChooser.vue'

import { RallyRoundDefaultTeamlogo } from '@/lib/models/RallyRoundDefaultTeamlogo'
import { MinioRessource } from '@/lib/models/MinioRessource'

@Component({
  components: {
    BacButton,
    PictureChooser
  }
})
export default class RallyRoundDefaultTeamlogoChooser extends Vue {
  pictures = []

  mounted () {
    this.loadPictures()
    this.$store.dispatch('loadRallyRound', this.$route.params.rallyRoundId)
  }

  async loadPictures () {
    this.pictures = []
    const pictures = await RallyRoundDefaultTeamlogo.getAll({})
    pictures.map(async (picture: any) => {
      (this.pictures as any).push(await MinioRessource.get(picture.minioRessourceId))
    })
  }

  async pictureSaved (data: any) {
    const rallyRoundDefaultTeamlogo = new RallyRoundDefaultTeamlogo()
    rallyRoundDefaultTeamlogo.minioRessourceId = data.id
    await rallyRoundDefaultTeamlogo.create()
    await this.loadPictures()
    this.$store.dispatch('forceReloadRallyRound', this.$route.params.rallyRoundId)
  }

  async saveSelectedPicture (id: number) {
    this.$store.state.PageURLRallyRound.rallyRound.defaultTeamLogoId = id
    await this.$store.state.PageURLRallyRound.rallyRound.update()
    this.$store.dispatch('forceReloadRallyRound', this.$route.params.rallyRoundId)
  }
}
